import React from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router';
import { Redirect } from 'react-router-dom';

import { useMount } from '@provider-portal/common/hooks/useMount';
import { AppRoutes } from 'AppRoutes';

import { selectProviderAction } from 'rdx/account';
import { setSelectedSupportCaseAction } from 'rdx/support';

function parseNumberQueryParam(param?: string): number | undefined {
  const parsedParam = Number(param);
  if (!Number.isNaN(param) && parsedParam > 0) {
    return parsedParam;
  }
  return undefined;
}

export const SupportCaseRedirect: React.FC = () => {
  const dispatch = useDispatch();

  const queryParams = new URLSearchParams(useLocation().search);
  const selectedCaseId = parseNumberQueryParam(queryParams.get('selected_case_id'));
  const providerId = parseNumberQueryParam(queryParams.get('provider_id'));

  useMount(() => {
    dispatch(selectProviderAction(providerId));
    dispatch(setSelectedSupportCaseAction({ case_id: selectedCaseId, provider_id: providerId }));
  });

  return <Redirect to={AppRoutes.HOME} />;
};
